<template>
  <div id="app">
    <div class="logo" v-if="isPC">
      <img src="./assets/logo.png" />
      <span>一叠微书·重新定义内容电商</span>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isPC: true // 判断是PC端还是mobile端
    }
  },
  created() {
    const href = window.location.href;
    if (this.endsWith(href, 'CID') || this.endsWith(href, 'agreement') || this.endsWith(href, 'policy')) {
      this.isPC = false
    } else if (/MicroMessenger|wxwork| micromessenger /i.test(navigator.userAgent)) {
      this.isPC = false
    } else if (
      /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
        navigator.userAgent
      )
    ) {
      this.isPC = false
    }
  },
  methods: {
    endsWith(str, searchString) {
      let index = str.length - searchString.length;
      return index >= 0 && str.indexOf(searchString, index) === index;
    }
  }
}
</script>

<style lang="less">
html,
body,
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

/*logo样式*/
.logo {
  height: 100px;
  position: fixed;
  z-index: 999;
  padding: 22px 0 0 32px;
  width: 100%;
  text-align: left;
  background: linear-gradient(to bottom,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0) 100%);
  display: flex;
  align-items: center;
}

.logo img {
  margin-right: 12px;
}

.logo span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

/* start:以下是PC端更改swiper的样式 */
.swiper-container-vertical>.swiper-pagination-bullets {
  right: 0 !important;
}

/*垂直轮播图的分页样式*/
.my-swiper {
  .swiper-pagination-bullet {
    width: 119px !important;
    height: 32px !important;
    font-size: 14px !important;
    font-family: PingFang SC !important;
    font-weight: 400 !important;
    color: rgba(255, 255, 255, 1) !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-bottom: 58px !important;
    border-radius: 0 !important;
    background-color: transparent !important;
    opacity: 1 !important;
  }

  .swiper-pagination-bullet-active {
    background: rgba(252, 199, 7, 1) !important;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.52) !important;
    border-radius: 16px 0px 0px 16px !important;
    color: rgba(0, 0, 0, 1) !important;
  }
}

.index-swiper {
  .swiper-pagination-bullet {
    width: 10px !important;
    height: 10px !important;
    font-size: 14px !important;
    font-family: PingFang SC !important;
    font-weight: 400 !important;
    color: rgba(255, 255, 255, 1) !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    /*margin-bottom: 58px !important;*/
    box-sizing: border-box;
    border-radius: 50% !important;
    background-color: #ffffff !important;
    opacity: 1 !important;
    transition: width 1s linear;
  }

  .swiper-pagination-bullet-active {
    width: 30px !important;
    background: #ffffff !important;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.52) !important;
    box-sizing: border-box;
    border-radius: 16px !important;
    color: rgba(0, 0, 0, 1) !important;
  }
}

/* end:以上是PC端更改swiper的样式 */
/* start:以下是mobile端更改swiper的样式 */
.my-h5-swiper {
  .swiper-pagination-bullet {
    width: 8px !important;
    height: 8px !important;
    background: rgba(159, 159, 159, 1) !important;
    opacity: 1 !important;
    margin: 13px 0;
    display: block;
  }

  .swiper-pagination-bullet-text {
    margin: 13px 0;
    display: block;
    color: rgba(159, 159, 159, 1);
    width: 11px;
    font-size: 12px;
    font-weight: 600;
    line-height: 13px;
  }

  .swiper-pagination-custom {
    right: 10px !important;
    top: 50% !important;
    transform: translate3d(0px, -50%, 0) !important;
    left: auto !important;
    bottom: auto !important;
    width: auto !important;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

/* end:以上是mobile端更改swiper的样式 */
/*start:这是去除video播放按钮的样式 */
*::-webkit-media-controls-panel {
  display: none !important;
  -webkit-appearance: none;
}

*::--webkit-media-controls-play-button {
  display: none !important;
  -webkit-appearance: none;
}

*::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

/*end:这是去除video播放按钮的样式 */
</style>



// WEBPACK FOOTER //
// src/App.vue